export enum DisplayMode {
    config='1',
    preview='2'
}